// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    /* overflow: hidden; */
    height: 100vh;
}
.adminNav{
    background-color: #453D4D;
    z-index: 1111;
}
main.admin-content{
    height: 100%;
    overflow: auto;
    width: 100%;
    max-width: 100%;
    padding-bottom: 40px;
}
#root{
    height: 100%;
}
.threeDots {
    background: #8fb940;
    width: 40px;
    height: 40px;
    border-radius: 50px;
}
.adminNav .navbar-brand {
    display: none;
}
.adminSideBar {
    width: 270px;
    background-color: #453D4D;
    padding: 20px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 11111;
}
.admin-main {
    width: calc(100% - 270px);
    margin-left: auto;
  }
  .sideBarLinks a {
    color: #F8F8F7;
    font-size: 18px;
    font-weight: 500;
    transition: color 0.3s;
}
.sideBarLinks a.active, .sideBarLinks a:hover {
    color: #DFEB7D;
}
.footer-container.adminFooter {
    z-index: 111;
}
.threeDots.inTable {
    width: 30px !important;
    height: 30px !important;
}
.forQr{
    width: 100%;
    height: auto;
    border: 2px dashed green;
    margin-bottom: 1rem;
    padding: 20px;
    border-radius: 15px;
}
.dropdown-menu {
    border: 1px solid #CCCCCC;
    overflow: hidden;
    border-radius: 8px;
    background: #fff !important;
    transition: display 0.3s;
}

.dropdown-item {
    color: #000000 !important;
    background: transparent !important;
    font-weight: 500 !important;
    transition: color 0.3s;
    cursor: pointer;

}
.start-inharit{
    left: inherit !important;
}
.dropdown-item.active, .dropdown-item:hover {
    color: #8fb940 !important;
}
.qrImg{
    width: '80%';
    height: 'auto';
    object-Fit: 'cover';
}
.theme-color {
    color: #8fb940 !important;
}

.sucess{
    width: 160px !important;
    margin: auto;
    display: flex;
    margin-top: -32px;
}
.footer-container.buyerFooter {
    display: none;
}
.forBuyerQr{
    height: 91px !important;
    object-fit: contain;
}
.modal-content {
    border: 4px solid #8fb940 !important;
    border-radius: 19px !important;
}
.hideInput{
        opacity: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
}
@media (max-width:992px) {
    .admin-layout.admin-layout-sm .adminSideBar {
        transform: translate(-270px);
    }
    .admin-main {
        width: 100%;
        margin-left: auto;
    }
    .admin-layout .adminNav .navbar-brand {
        display: flex;
    }
    .adminSideBar {
       transform: translate() 0.3s;
        z-index: 1111;
    }
}
@media (max-width:767px) {
    .group-offers-container {
        padding: 20px 0px !important;
    }
    .fat-arrow {
        width: 150px !important;
        height: 48px !important;
    }
    .workflow-steps {
        /* min-width: 1553px !important; */
    }
    .fat-arrow:after {
        border-left: 20px solid white !important;
        border-top: 33px solid transparent !important;
        border-bottom: 25px solid transparent !important;
    }
    .fat-arrow:before {
        right: -19px !important;
        border-top: 24px solid transparent !important;
        border-bottom: 24px solid transparent !important;
    }
    .adminTitle {
        font-size: 17px;
    }
    .create-group-offer-button2 {
        padding: 6px 14px;
        font-size: 14px;
    }
    .group-offers-container {
        padding: 20px 0;
    }
    .group-offers-table th {
        font-size: 14px;
    }
    .threeDots {
        background: #8fb940;
        width: 30px;
        height: 30px;
        border-radius: 50px;
    }
    .navbar-brand img{
        max-width: 130px;
    }
}

td.order-info {
    min-width: 182px !important;
    width: 188px !important;
}



  /* Flex container to ensure all arrows fit in one row */
  .fat-arrow-wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 21px;
    flex-wrap: nowrap;
  }
  
  /* Fat arrow styles */
  .fat-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 110px;
    height: 70px;
    background: #F4F4F4;
    color: #5B17A0;
    position: relative;
    flex-shrink: 0;
    text-align: center;
    padding-left:25px;
}
  
  .fat-arrow .inner {
    font-weight: 600;
    font-size: 13px;
    overflow-wrap: break-word;
  }
  
  .fat-arrow:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid white;
    border-top: 35px solid transparent;
    border-bottom: 35px solid transparent;
  }
  
  .fat-arrow:before {
    content: '';
    position: absolute;
    right: -20px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid #F4F4F4;
    border-top: 35px solid transparent;
    border-bottom: 35px solid transparent;
  }
  
  .fat-arrow.highlight {
    background: #5B17A0;
    color: #fff;
  }
  
  .fat-arrow.highlight::before {
    border-left-color: #5B17A0;
  }
  
  @media (max-width: 1200px) {
    .fat-arrow {
      width: 10%;
    }
  }
  
  @media (max-width: 992px) {
    .fat-arrow {
      width: 12%;
    }
  }

  .table {
    width: 100%;
    margin-top: 20px;
  }
  .workflow-steps {
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    /* min-width: 1778px; */
  }
  
  
  .customInput{
    border: 1px solid #E1E0DF;
    box-shadow: none !important;
    border-radius: 50px !important;
    height: 50px;
  }
  .customInput:focus, textarea:focus, input:focus{
    border: 1px solid #8fb940 !important;
    overflow: auto;
  }
  input.pdfInput:focus-visible{
    outline: 0 !important;
  }
  input.pdfInput{
    outline: 0 !important;
    border: 0 !important;
    border-bottom: 1px solid !important;
    font-size: 16px;
    font-weight: 600;
    color: #000 !important;
  }
  .create-group-offer-button2 {
    background-color: #453D4D;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 63px;
    cursor: pointer;
   
}
.group-offers-container {
    padding: 20px;
    border-radius: 8px;
    margin: 0 auto;
  }
  .heading-container h2 {
    text-align: left;
    color: #333;
}
.themeColor2{
  color: #602998 !important;
}
span.d-block.fw-bold.timeBox {
  width: 51px;
  background: #453D4D;
  height: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #fff;
  line-height: 40px;
}
.create-group-offer-button2 {
    background-color:  #453D4D;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 63px;
    cursor: pointer;
    /* float: right; */
    /* margin-top: 1.5%; */
  }
  textarea{
    height: auto !important;
    border-radius: 15px !important;
  }
  .group-offer-table-main{
    background-color: white;
    border-radius: 5px;
  
    margin-top: 20px;
  }
  .dropdown-menu{
    left: inherit !important;
    right: 0 !important;
  }
  .group-offers-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .group-offers-table th,
  .group-offers-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  .group-offers-table th {
    font-weight: bold;

  }
  .group-offers-table tbody{
    padding-top: 15px;
    padding-bottom: 151px;
  }
  
`, "",{"version":3,"sources":["webpack://./src/layouts/admin/admin.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;;AAEnB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;AACA;QACQ,UAAU;QACV,WAAW;QACX,YAAY;QACZ,UAAU;QACV,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,SAAS;QACT,MAAM;AACd;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;OACG,2BAA2B;QAC1B,aAAa;IACjB;AACJ;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,uBAAuB;QACvB,uBAAuB;IAC3B;IACA;QACI,kCAAkC;IACtC;IACA;QACI,wCAAwC;QACxC,6CAA6C;QAC7C,gDAAgD;IACpD;IACA;QACI,uBAAuB;QACvB,6CAA6C;QAC7C,gDAAgD;IACpD;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;;;EAIE,uDAAuD;EACvD;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;EAEE;IACE,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kCAAkC;IAClC,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,kCAAkC;IAClC,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,uBAAuB;EACzB;;;EAGA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,oCAAoC;IACpC,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;;AAEnB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,WAAW;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,uBAAuB;IACvB,kBAAkB;;IAElB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;;EAEnB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB","sourcesContent":["body{\n    /* overflow: hidden; */\n    height: 100vh;\n}\n.adminNav{\n    background-color: #453D4D;\n    z-index: 1111;\n}\nmain.admin-content{\n    height: 100%;\n    overflow: auto;\n    width: 100%;\n    max-width: 100%;\n    padding-bottom: 40px;\n}\n#root{\n    height: 100%;\n}\n.threeDots {\n    background: #8fb940;\n    width: 40px;\n    height: 40px;\n    border-radius: 50px;\n}\n.adminNav .navbar-brand {\n    display: none;\n}\n.adminSideBar {\n    width: 270px;\n    background-color: #453D4D;\n    padding: 20px;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 11111;\n}\n.admin-main {\n    width: calc(100% - 270px);\n    margin-left: auto;\n  }\n  .sideBarLinks a {\n    color: #F8F8F7;\n    font-size: 18px;\n    font-weight: 500;\n    transition: color 0.3s;\n}\n.sideBarLinks a.active, .sideBarLinks a:hover {\n    color: #DFEB7D;\n}\n.footer-container.adminFooter {\n    z-index: 111;\n}\n.threeDots.inTable {\n    width: 30px !important;\n    height: 30px !important;\n}\n.forQr{\n    width: 100%;\n    height: auto;\n    border: 2px dashed green;\n    margin-bottom: 1rem;\n    padding: 20px;\n    border-radius: 15px;\n}\n.dropdown-menu {\n    border: 1px solid #CCCCCC;\n    overflow: hidden;\n    border-radius: 8px;\n    background: #fff !important;\n    transition: display 0.3s;\n}\n\n.dropdown-item {\n    color: #000000 !important;\n    background: transparent !important;\n    font-weight: 500 !important;\n    transition: color 0.3s;\n    cursor: pointer;\n\n}\n.start-inharit{\n    left: inherit !important;\n}\n.dropdown-item.active, .dropdown-item:hover {\n    color: #8fb940 !important;\n}\n.qrImg{\n    width: '80%';\n    height: 'auto';\n    object-Fit: 'cover';\n}\n.theme-color {\n    color: #8fb940 !important;\n}\n\n.sucess{\n    width: 160px !important;\n    margin: auto;\n    display: flex;\n    margin-top: -32px;\n}\n.footer-container.buyerFooter {\n    display: none;\n}\n.forBuyerQr{\n    height: 91px !important;\n    object-fit: contain;\n}\n.modal-content {\n    border: 4px solid #8fb940 !important;\n    border-radius: 19px !important;\n}\n.hideInput{\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 1;\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        top: 0;\n}\n@media (max-width:992px) {\n    .admin-layout.admin-layout-sm .adminSideBar {\n        transform: translate(-270px);\n    }\n    .admin-main {\n        width: 100%;\n        margin-left: auto;\n    }\n    .admin-layout .adminNav .navbar-brand {\n        display: flex;\n    }\n    .adminSideBar {\n       transform: translate() 0.3s;\n        z-index: 1111;\n    }\n}\n@media (max-width:767px) {\n    .group-offers-container {\n        padding: 20px 0px !important;\n    }\n    .fat-arrow {\n        width: 150px !important;\n        height: 48px !important;\n    }\n    .workflow-steps {\n        /* min-width: 1553px !important; */\n    }\n    .fat-arrow:after {\n        border-left: 20px solid white !important;\n        border-top: 33px solid transparent !important;\n        border-bottom: 25px solid transparent !important;\n    }\n    .fat-arrow:before {\n        right: -19px !important;\n        border-top: 24px solid transparent !important;\n        border-bottom: 24px solid transparent !important;\n    }\n    .adminTitle {\n        font-size: 17px;\n    }\n    .create-group-offer-button2 {\n        padding: 6px 14px;\n        font-size: 14px;\n    }\n    .group-offers-container {\n        padding: 20px 0;\n    }\n    .group-offers-table th {\n        font-size: 14px;\n    }\n    .threeDots {\n        background: #8fb940;\n        width: 30px;\n        height: 30px;\n        border-radius: 50px;\n    }\n    .navbar-brand img{\n        max-width: 130px;\n    }\n}\n\ntd.order-info {\n    min-width: 182px !important;\n    width: 188px !important;\n}\n\n\n\n  /* Flex container to ensure all arrows fit in one row */\n  .fat-arrow-wrapper {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 21px;\n    flex-wrap: nowrap;\n  }\n  \n  /* Fat arrow styles */\n  .fat-arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 110px;\n    height: 70px;\n    background: #F4F4F4;\n    color: #5B17A0;\n    position: relative;\n    flex-shrink: 0;\n    text-align: center;\n    padding-left:25px;\n}\n  \n  .fat-arrow .inner {\n    font-weight: 600;\n    font-size: 13px;\n    overflow-wrap: break-word;\n  }\n  \n  .fat-arrow:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 0;\n    height: 0;\n    border-left: 20px solid white;\n    border-top: 35px solid transparent;\n    border-bottom: 35px solid transparent;\n  }\n  \n  .fat-arrow:before {\n    content: '';\n    position: absolute;\n    right: -20px;\n    bottom: 0;\n    width: 0;\n    height: 0;\n    border-left: 20px solid #F4F4F4;\n    border-top: 35px solid transparent;\n    border-bottom: 35px solid transparent;\n  }\n  \n  .fat-arrow.highlight {\n    background: #5B17A0;\n    color: #fff;\n  }\n  \n  .fat-arrow.highlight::before {\n    border-left-color: #5B17A0;\n  }\n  \n  @media (max-width: 1200px) {\n    .fat-arrow {\n      width: 10%;\n    }\n  }\n  \n  @media (max-width: 992px) {\n    .fat-arrow {\n      width: 12%;\n    }\n  }\n\n  .table {\n    width: 100%;\n    margin-top: 20px;\n  }\n  .workflow-steps {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 20px;\n    /* min-width: 1778px; */\n  }\n  \n  \n  .customInput{\n    border: 1px solid #E1E0DF;\n    box-shadow: none !important;\n    border-radius: 50px !important;\n    height: 50px;\n  }\n  .customInput:focus, textarea:focus, input:focus{\n    border: 1px solid #8fb940 !important;\n    overflow: auto;\n  }\n  input.pdfInput:focus-visible{\n    outline: 0 !important;\n  }\n  input.pdfInput{\n    outline: 0 !important;\n    border: 0 !important;\n    border-bottom: 1px solid !important;\n    font-size: 16px;\n    font-weight: 600;\n    color: #000 !important;\n  }\n  .create-group-offer-button2 {\n    background-color: #453D4D;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 63px;\n    cursor: pointer;\n   \n}\n.group-offers-container {\n    padding: 20px;\n    border-radius: 8px;\n    margin: 0 auto;\n  }\n  .heading-container h2 {\n    text-align: left;\n    color: #333;\n}\n.themeColor2{\n  color: #602998 !important;\n}\nspan.d-block.fw-bold.timeBox {\n  width: 51px;\n  background: #453D4D;\n  height: 40px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  color: #fff;\n  line-height: 40px;\n}\n.create-group-offer-button2 {\n    background-color:  #453D4D;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 63px;\n    cursor: pointer;\n    /* float: right; */\n    /* margin-top: 1.5%; */\n  }\n  textarea{\n    height: auto !important;\n    border-radius: 15px !important;\n  }\n  .group-offer-table-main{\n    background-color: white;\n    border-radius: 5px;\n  \n    margin-top: 20px;\n  }\n  .dropdown-menu{\n    left: inherit !important;\n    right: 0 !important;\n  }\n  .group-offers-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .group-offers-table th,\n  .group-offers-table td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .group-offers-table th {\n    font-weight: bold;\n\n  }\n  .group-offers-table tbody{\n    padding-top: 15px;\n    padding-bottom: 151px;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
